__turbopack_context__.v({
  "button": "InstallExtension-module__RfErkG__button",
});
